import Auth from '~models/auth'
import AuthRepository from '~repositories/impl/auth-repository'
import Mixpanel from '~utils/mixpanel'
import { setToken } from '~utils/token'

import { useMutation, UseMutationOptions } from '@tanstack/react-query'

const useSocialLogIn = (
  options?: UseMutationOptions<Auth.LogIn.Response, Error, Auth.ISocialLogin>
) => {
  return useMutation({
    ...options,
    mutationFn: AuthRepository.socialLogin,
    onSuccess: (res, req, ctx) => {
      options?.onSuccess?.(res, req, ctx)
      setToken(res.access_token)
      Mixpanel.identify(res.owner.id)

      if (res.is_first_login) {
        Mixpanel.logEvent('sign_up: completed', {
          account_type: req.platform,
        })
      }

      Mixpanel.logEvent('account: logged_in', {
        account_type: req.platform,
      })
    },
  })
}

export default useSocialLogIn
